/* ลิงก์เก่า /portal/login — ลูกค้าใช้หน้า /login เดียวกับพนักงานแล้ว */
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function PortalLogin() {
  const { search } = useLocation();
  return <Navigate to={`/login${search}`} replace />;
}
